import { Component, inject } from "@angular/core";
import { ButtonComponent } from "@husbanken/designsystem-angular-core";
import { Router } from "@angular/router";

@Component({
  selector: "bko-kartlegg-card",
  imports: [ButtonComponent],
  templateUrl: "./kartlegg-card.html",
  styleUrl: "./kartlegg-card.scss",
})
export class KartleggCard {
  private router: Router = inject(Router);

  navigateToKartlegging(): void {
    this.router.navigate(["/kartlegging"]);
  }
}
